import {Component, OnInit} from '@angular/core';
import {BatchRpcService} from "@alpha/services";
import {ActivatedRoute, Router} from "@angular/router";
import {Batch} from "../../services";

@Component({
  selector: 'view-batch-current-redirect',
  templateUrl: './batch-current-redirect.component.html',
  styleUrls: ['./batch-current-redirect.component.scss']
})
export class BatchCurrentRedirectComponent implements OnInit {
  constructor(
    private batch: BatchRpcService,
    private route: ActivatedRoute,
    private router: Router,
  ) {

  }

  ngOnInit() {
    this.route.params.subscribe(async (draft) => {
      if (draft.bid) {
        try {
          const batch: Batch = await this.batch.getLatestBatch(draft.bid);
          await this.router.navigate(['dashboard', 'batch', batch.bid]);
        } catch (e) {
          console.error(e);
          await this.router.navigate(['dashboard', 'batches']);
        }
      }else{
        await this.router.navigate(['dashboard', 'batches']);
      }
    });
  }
}
